module.exports = __webpack_public_path__ + "img/ac.282c172a.png";